export const baseUrl = () => document.body.dataset.hotelApi;

export const csrfToken = () =>
    document.querySelector('meta[name="csrf-token"]')?.content
    || document.querySelector('input[name="_token"]')?.value;
